/** Установка PWA: перехват beforeinstallprompt (Android/Chrome) + определение iOS Safari */

type BeforeInstallPromptEvent = Event & {
    prompt: () => Promise<void>
    userChoice: Promise<{ outcome: "accepted" | "dismissed" }>
}

let deferredPrompt: BeforeInstallPromptEvent | null = null
const listeners = new Set<() => void>()

function notify() {
    listeners.forEach(l => l())
}

if (typeof window !== "undefined") {
    window.addEventListener("beforeinstallprompt", e => {
        e.preventDefault()
        deferredPrompt = e as BeforeInstallPromptEvent
        notify()
    })
    window.addEventListener("appinstalled", () => {
        deferredPrompt = null
        notify()
    })
}

export function subscribePwaInstall(listener: () => void): () => void {
    listeners.add(listener)
    return () => listeners.delete(listener)
}

export function canPromptPwaInstall(): boolean {
    return deferredPrompt !== null
}

/** Показать системный диалог установки. true — пользователь согласился */
export async function promptPwaInstall(): Promise<boolean> {
    const evt = deferredPrompt
    if (!evt) return false
    await evt.prompt()
    const { outcome } = await evt.userChoice
    deferredPrompt = null
    notify()
    return outcome === "accepted"
}

export function isIosSafari(): boolean {
    if (typeof navigator === "undefined") return false
    const ua = navigator.userAgent
    const isIos = /iPhone|iPad|iPod/.test(ua) || (ua.includes("Macintosh") && navigator.maxTouchPoints > 1)
    /* Chrome/Firefox/Яндекс на iOS не умеют ставить PWA — инструкция только для Safari */
    const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|YaBrowser|EdgiOS|OPiOS/.test(ua)
    return isIos && isSafari
}

export function isStandalone(): boolean {
    if (typeof window === "undefined") return false
    return (
        window.matchMedia("(display-mode: standalone)").matches ||
        (navigator as { standalone?: boolean }).standalone === true
    )
}
